var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "web-agent-preview" }, [
    _c("h4", [_vm._v("Preview")]),
    _vm._v(" "),
    _c("div", { staticClass: "preview-container" }, [
      _c(
        "div",
        {
          staticClass: "mock-page",
          style: {
            backgroundColor: "#f5f5f5",
            backgroundImage:
              "linear-gradient(#e5e5e5 1px, transparent 1px), linear-gradient(90deg, #e5e5e5 1px, transparent 1px)",
            backgroundSize: "20px 20px",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "preview-bar-container",
              class: _vm.settings.position,
              style: _vm.getPositionStyle(),
            },
            [
              _c(
                "div",
                {
                  staticClass: "preview-bar",
                  style: {
                    backgroundColor:
                      _vm.settings.colors.containerBackgroundColor,
                    borderColor: _vm.settings.colors.containerBorderColor,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "preview-icon",
                      style: {
                        background:
                          "linear-gradient(135deg, " +
                          _vm.settings.colors.iconBackgroundColor +
                          ", " +
                          _vm.settings.colors.iconBorderColor +
                          ")",
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "preview-icon-circle",
                        style: {
                          stroke: _vm.settings.colors.inactiveCallBorderColor,
                          fill: _vm.settings.colors.iconBorderColor,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "preview-button",
                      style: {
                        backgroundColor:
                          _vm.settings.colors.buttonBackgroundColor,
                        color: _vm.settings.colors.buttonTextColor,
                      },
                    },
                    [
                      _c("span", { staticClass: "preview-button-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "10",
                              height: "10",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.31 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z",
                                fill: _vm.settings.colors.buttonTextColor,
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "preview-button-text" }, [
                        _vm._v(_vm._s(_vm.settings.buttonText || "Voice Chat")),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.settings.showLanguageSelector
                    ? _c(
                        "div",
                        {
                          staticClass: "preview-language-selector",
                          style: {
                            backgroundColor:
                              _vm.settings.colors
                                .languageSelectorBackgroundColor,
                            color:
                              _vm.settings.colors.languageSelectorTextColor,
                            borderColor:
                              _vm.settings.colors.languageSelectorBorderColor,
                          },
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("span", { staticClass: "preview-arrow" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "8",
                                  height: "8",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M7 10l5 5 5-5",
                                    stroke:
                                      _vm.settings.colors
                                        .languageSelectorTextColor,
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              !_vm.settings.hidePoweredByText
                ? _c(
                    "div",
                    {
                      staticClass: "preview-powered-by",
                      style: { color: _vm.settings.colors.poweredByTextColor },
                    },
                    [
                      _vm._v(
                        "\n                    Powered by Supsis AI\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "preview-flag" }, [
      _c("img", {
        staticStyle: { width: "14px", height: "10px", "border-radius": "2px" },
        attrs: { src: "https://flagcdn.com/w20/tr.png", alt: "TR" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }